import React, { useEffect } from 'react';
import { Layout, theme } from 'antd';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import TitleBar from 'components/TitleBar';
import GoBackButton from 'components/GoBackButton';
import { RootState } from 'store/configureStore';
import i18n from 'constants/translation/i18n';
import * as MainStyled from 'components/Layouts/Layout.styled';

const { Content, Sider } = Layout;
const { useToken } = theme;

interface ILibraryLayoutProps {
  children: React.ReactNode;
}

const LibraryLayout: React.FC<ILibraryLayoutProps> = ({ children }) => {
  const { token } = useToken();
  const { lang } = useSelector((state: RootState) => ({
    lang: state.global.lang
  }));
  const location = useLocation();

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  const getNavigationButtons = () => {
    if (location.pathname.startsWith('/library/data-entry/')) {
      return (
        <>
          <GoBackButton
            to='/library/data-entry'
            text={i18n.t('GO_TO_DATA_ENTRY')}
          />
          <GoBackButton to='/library' text={i18n.t('GO_TO_LIBRARY')} />
          <GoBackButton
            to='/working_area'
            text={i18n.t('GO_TO_WORKING_AREAS')}
          />
        </>
      );
    } else if (location.pathname.startsWith('/library/')) {
      return (
        <>
          <GoBackButton to='/library' text={i18n.t('GO_TO_LIBRARY')} />
          <GoBackButton
            to='/working_area'
            text={i18n.t('GO_TO_WORKING_AREAS')}
          />
        </>
      );
    } else {
      return (
        <GoBackButton to='/working_area' text={i18n.t('GO_TO_WORKING_AREAS')} />
      );
    }
  };

  return (
    <MainStyled.StyledLayout token={token}>
      <TitleBar
        title={i18n.t('LIBRARY')}
        goBackButtons={getNavigationButtons()}
      />
      <MainStyled.StyledLayout token={token}>
        <Layout>
          <Content>
            <MainStyled.Container>{children}</MainStyled.Container>
          </Content>
        </Layout>
        <Sider />
      </MainStyled.StyledLayout>
    </MainStyled.StyledLayout>
  );
};

export default LibraryLayout;
